import { dominosStore } from '../../../main';
import { getConfig } from '../../../modules/AppMain/config';
import { getPizzaOptionsAsString } from '../../../modules/OrderSummupDelivery/helpers';
import { goFish } from '../api';
import { productTypes } from './datalayers';

export const dataLayerPush = ({ eventName, currency, ecommerce, value }: { eventName: string; currency?: string, ecommerce?: any, value?: number }) => {
    if (typeof window.dataLayer !== 'undefined') {
        const dLayerParams: NewDataLayerType = {
            event: eventName
        };

        if (ecommerce) {
            //important notice - have to place object keys as string 'obj.key' !!! within ecommerce object
            dLayerParams['ecommerce'] = ecommerce;
        }

        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(dLayerParams);
    }
};

export const createLayerProducts = async ({
    products,
    localguid
}: {
    products?: AppCartProduct[];
    localguid: string;
}) => {
    try {
        // Retrieve the products to extract tags. Don't returns packings.
        const allProductsFromCache = await goFish({
            api: 'getproductlist',
            data: { localguid }
        }).then((response: ProductsList) => {
            if (response.Status) {
                return response.Product || [];
            } else {
                return [];
            }
        });
        let productsArray: NewDataLayerSingleProductType[] = [];
        if (!products) {
            dominosStore.cartStore.products.map(product => {
                const productFromProductList = allProductsFromCache.find(
                    p => p.Id === product.Data.Id
                );

                const prod = createLayerSingleProduct({
                    productFromCart: product,
                    productFromProductList
                });
                productsArray.push(prod);
            });
        } else {
            products.map(product => {
                const productFromProductList = allProductsFromCache.find(
                    p => p.Id === product.Data.Id
                );
                const prod = createLayerSingleProduct({
                    productFromCart: product,
                    productFromProductList
                });
                productsArray.push(prod);
            });
        }
        return productsArray;
    } catch (e) {
        console.log(e);
    }
};

export const createTagsString = (tags: { Name: string }[] | null | undefined) => {
    return tags?.length ? tags.map(tag => tag.Name.toLowerCase()).join(', ') : undefined;
};

export const createLayerSingleProduct = ({
    productFromCart,
    productFromProductList
}: {
    productFromCart: AppCartProduct;
    // productFromProductList is undefined if it is package
    productFromProductList?: Product;
}) => {
    try {
        const productTags = createTagsString(productFromProductList?.Tags);
        const { categories } = getConfig();
        const categoryGuid = productFromProductList?.CategoryGuid;
        const price = productFromCart.Data.Count > 0
            ? productFromCart.Data.Sum / productFromCart.Data.Count
            : productFromCart.Data.Sum;

        const prod: NewDataLayerSingleProductType = {
            item_id: productFromCart.Data.Id,
            item_name: productFromCart.Data.Name,
            price,
            item_brand: 'Dominos',
            item_category: productTypes[productFromCart.Type],
            /* zmienione 19.01.2026 */
            item_category2: productFromCart.Data.DocumentName === 'Creator' ? 'Pizza' : (categoryGuid ? (categories[categoryGuid] || 'opakowanie') : 'opakowanie'),
            /* zmienione 19.01.2026 */
            item_variant: '',
            quantity: productFromCart.Data.Count,
            coupon: '',
            /* zmienione 19.01.2026 */
            item_category3: productTags,
            /* zmienione 19.01.2026 */
        };
        switch (productFromCart.Type) {
            case 1:
                prod['item_variant'] =
                    productFromCart.Data.Name.toUpperCase() +
                    ', ' +
                    getPizzaOptionsAsString(productFromCart.Data);
                break;
            case 99:
                prod['item_variant'] = productFromCart.Data.CartPizzas.map(
                    p => p.Name.toUpperCase() + ', ' + getPizzaOptionsAsString(p)
                ).join(', ');
                break;
            case 2:
                prod['coupon'] = productFromCart.Data.Name;
                prod['item_variant'] = productFromCart.Data.CartGroups.map(
                    group =>
                        group.CartPizzas.map(
                            p => p.Name.toUpperCase() + ', ' + getPizzaOptionsAsString(p)
                        ).join(', ') +
                        group.CartProducts.map(p =>
                            p.Count > 1 ? p.Name + ' x ' + p.Count : p.Name
                        ).join(', ')
                ).join(', ');
                break;
            case 98:
                prod['item_variant'] = productFromCart.Data.Name.toUpperCase();
                break;
        }
        return prod;
    } catch (e) {
        console.error(e);
    }
};

export const createLayerImpressions = (products: AppProduct[]) => {
    try {
        let impressions: DataLayerGA4ProductImpressionType[] = [];
        const { categories } = getConfig();

        if (typeof products != 'undefined') {
            products.map((p, index) => {
                const productTags = createTagsString(p.Tags);
                const categoryGuid = p.CategoryGuid;

                let singleProductImpression = {
                    item_id: p.Id,
                    item_name: p.Name,
                    item_brand: 'Dominos',
                    item_category: categories[categoryGuid].toLocaleLowerCase(),
                    item_category2: categories[categoryGuid] || 'opakowanie',
                    /* zmienione 19.01.2026 */
                    // index + 1 creates real position instead of array index
                    index: index + 1,
                    item_category3: productTags
                };
                impressions.push(singleProductImpression);
            });
        }
        return impressions;
    } catch (e) {
        console.error(e);
    }
};


export const createGA4LayerImpressions = (products: AppProduct[]) => {
    try {
        let impressions: DataLayerGA4ProductImpressionType[] = [];
        if (typeof products != 'undefined') {
            const { categories } = getConfig();
            products.map((p, index) => {
                const productTags = createTagsString(p.Tags);
                const itemListName = (p as any).item_list_name || dominosStore.cartStore.currentMenuCategory;
                let singleProductImpression = {
                    'item_id': p.Id,
                    'item_name': p.Name,
                    'item_brand': 'Dominos',
                    'item_list_name': itemListName,
                    'item_category': productTypes[p.Type],
                    /* zmienione 19.01.2026 */
                    'item_category2': categories[p.CategoryGuid] ? categories[p.CategoryGuid] : 'opakowanie',
                    'item_category3': productTags ?? '',
                    /* zmienione 19.01.2026 */
                    'index': index + 1,
                    'item_variant': '',
                    'price': p.Price,
                    'quantity': p.Quantity || 1
                };
                impressions.push(singleProductImpression);
            });
        }
        return impressions;
    } 
    catch (e) {
        console.error(e);
    }
};